import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Input,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDocumentImageModal } from '../../types/interfaces';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookOpen, faDownload, faFileInvoice, faIdCard, faMoneyCheck, faPrint, faRedo, faSpinner, faUndo } from '@fortawesome/free-solid-svg-icons'
import { useReactToPrint } from 'react-to-print';

import Loading from '../Loading';
import { getFtpScan } from '../../flux/actions/clientActions';
import { downloadImg } from '../../services/misc';

const DocumentImageModal = ({ 
  modal,
  setModal,
  documentImage
 }: IDocumentImageModal) => {
  const [docImg, setDocImg] = useState<any>(undefined);
  const imgRef = useRef<any>(null);
  const [isRotating, setIsRotating] = useState(false);
  const [disablePrint, setDisablePrint] = useState(false);

  const handleToggle = () => setModal(!modal);

  useEffect(() => {
    setDocImg(documentImage?.file)
  }, [documentImage])

  const modalClosedHandle = () => {
    setDocImg(undefined);
  };

  const rotateImg = (base64: string, degrees: number, setImg: Function) => {
    if(isRotating)
      return
    setIsRotating(true);
    const image = new Image();
    image.src = base64;
    image.onload = function() {
      const canvas = document.createElement("canvas");
      const w = image.width;
      const h = image.height;
      const rads = degrees * Math.PI/180;
      let c = Math.cos(rads);
      let s = Math.sin(rads);
      if (s < 0) { s = -s; }
      if (c < 0) { c = -c; }
      //use translated width and height for new canvas
      canvas.width = h * s + w * c;
      canvas.height = h * c + w * s;
      //draw the rect in the center of the newly sized canvas
      const ctx = canvas.getContext("2d");
      if(ctx){
        ctx.translate(canvas.width/2, canvas.height/2);
        ctx.rotate(degrees * Math.PI / 180);
        ctx.drawImage(image, -image.width/2, -image.height/2);
        setImg(canvas.toDataURL("image/jpeg"));
        setIsRotating(false);
      }
    };
  }

  const printPageStyle = `
    @page {
      size: auto;
      margin: 0mm;
    }
    @media print {
      body {
        -webkit-print-color-adjust: exact;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .scanPreview {
        max-height: 100%;
        margin: 0;
        padding: 10px;
      }
    }
  `;

  const printHook = useReactToPrint({
    content: () => imgRef.current,
    pageStyle: printPageStyle
  });

  const printHandle = (printHook, setDisablePrint) => {
    if(printHook){
      setDisablePrint(true);
      printHook();
      setTimeout(() => setDisablePrint(false), 2000);
    }
  }

  // const downloadImg = (base64: string, fileNameStart: string) => {
  //   const datetimeAsText = new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear() + '_' + new Date().getHours() + '-' + new Date().getMinutes() + '-' + new Date().getSeconds();
  //   try{
  //     const downloadLink = document.createElement("a");
  //     downloadLink.href = base64;
  //     downloadLink.download = `${fileNameStart}_${datetimeAsText}`;
  //     downloadLink.click();
  //   }
  //   catch(e){
  //     console.error("error downloading enc image")
  //   }
  // }

  return (
    <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle} className="modal-dialog-large">
      <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faBookOpen} />&nbsp;&nbsp;Aperçu du document{documentImage?.type ? (" : " + documentImage.type) : ""}</ModalHeader>
      <ModalBody>
        <Container className="scanPreviewContainer">
          {docImg ? <Row>
            <Col xs="12">
              <div className="scanPreviewBtnsAndImgContainer">
                <img className="scanPreview" ref={imgRef} src={docImg}/>
                <div className="scanPreviewBtnsContainer">
                  <button onClick={() => rotateImg(docImg, -90, setDocImg)} title="Faire pivoter vers la gauche"><FontAwesomeIcon icon={faUndo} /></button>
                  <button onClick={() => rotateImg(docImg, 90, setDocImg)} title="Faire pivoter vers la droite"><FontAwesomeIcon icon={faRedo} /></button>
                  <button onClick={() => printHandle(printHook, setDisablePrint)} title="Imprimer" disabled={disablePrint}><FontAwesomeIcon icon={disablePrint ? faSpinner : faPrint} className={disablePrint ? "spinner" : ""} /></button>
                  <button onClick={() => downloadImg(docImg, `${(documentImage?.fileName || "document")}_pris_le`)} title="Télécharger"><FontAwesomeIcon icon={faDownload} /></button>
                </div>
              </div>
            </Col>
          </Row> : null}
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default connect(null, {})(DocumentImageModal);
